import { createHttpLink } from 'apollo-link-http';
import { runtimeConfig } from '@kiper/fns';

export default () =>
  createHttpLink({
    uri: runtimeConfig.RAZZLE_GRAPHQL_URL,
  });
